import { ProjectTypes } from '../../common/constants'

const maxNotificationJobNameLength = 50
export const archiveJobRedirectDelayMs = 1500

const formatJobNameForNotification = (jobName?: string) => {
  if (!jobName) {
    return ''
  }

  return jobName.length > maxNotificationJobNameLength
    ? `${jobName.slice(0, maxNotificationJobNameLength)}...`
    : jobName
}

export const buildArchiveJobNotificationMessage = (
  jobName: string | undefined,
  action: 'archived' | 'unarchived'
) => {
  const formattedJobName = formatJobNameForNotification(jobName)
  return formattedJobName
    ? `Job "${formattedJobName}" ${action}.`
    : `Job ${action}.`
}

export const buildArchiveJobDestination = (jobType?: number, sold: boolean = true) => {
  if (!sold) {
    return '/#!/estimates'
  }

  switch (jobType) {
    case ProjectTypes.Maintenance:
      return '/#!/maintenance'
    case ProjectTypes.Ticket:
      return '/#!/tickets'
    default:
      return '/#!/projects'
  }
}

type ArchiveJobTooltipState = {
  isCheckingArchive: boolean
  isArchiving: boolean
  isUnarchiving: boolean
  message?: string | null
}

export const buildArchiveJobTooltipText = ({
  isCheckingArchive,
  isArchiving,
  isUnarchiving,
  message
}: ArchiveJobTooltipState) => {
  if (isCheckingArchive) {
    return 'Checking if job may be archived...'
  }

  if (isArchiving) {
    return 'Archiving the job...'
  }

  if (isUnarchiving) {
    return 'Unarchiving the job...'
  }

  return message ?? 'This job cannot be archived yet.'
}
